module.exports = __webpack_public_path__ + "static/img/017_TO8_1478.3af0314.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/017_TO8_1478.jpg
// module id = sOeR
// module chunks = 0